var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55 12.5L.85 6.8l1.425-1.425L6.55 9.65 15.725.475 17.15 1.9 6.55 12.5z",
    fill: "#1C1B1F"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxOCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNTQ5NjEgMTIuNTAwMUwwLjg0OTYwOSA2LjgwMDFMMi4yNzQ2MSA1LjM3NTFMNi41NDk2MSA5LjY1MDFMMTUuNzI0NiAwLjQ3NTA5OEwxNy4xNDk2IDEuOTAwMUw2LjU0OTYxIDEyLjUwMDFaIiBmaWxsPSIjMUMxQjFGIi8+Cjwvc3ZnPgo=";
export { SvgCheck as ReactComponent };